import React, { PureComponent } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Row
} from "reactstrap";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory from "react-bootstrap-table2-filter";
import LottieLoader from '../../components/LottieLoader';
import lottieEmptyFile from '../../files/animation/empty_new.json';
import lottieLoaderFile from '../../files/animation/loading.json';
import moment from "moment";
import Swal from 'sweetalert2';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import ReportConfigration from "./ReportConfigration";
const _ = require("lodash");
class SchedularConfigurationReport extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reportSendError: null,
      reportSendStartDate: _.get(this.props, 'faxAndEmailScheduleDate.reportStartDate', moment().subtract(30, "d").format()),
      reportSendEndDate: _.get(this.props, 'faxAndEmailScheduleDate.reportEndDate', moment().endOf("day").utc().format()),
      reportSendDate: _.get(this.props, 'faxAndEmailScheduleDate.reportSendDate', null),
      dateRageFilter: false,
      dateRangeError: null,
      refreshKey: 0,
      SchedularReportConfiguration: [{
        key: "Monthly Graph and Log Book Schedule Report"
      }],
      isEditable: false,
      time : null,
      timeError : null
    };
    this.validateTime = this.validateTime.bind(this);
    this.dateRange = this.dateRange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.saveCustomScheduleInfo = this.saveCustomScheduleInfo.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  componentDidMount() {
    const userId = this.props.profile._id;
    this.props.dispatch({
      type: "DO_GET_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
      payload: {
        user: userId
      }
    });

  }
  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.faxAndEmailScheduleDate, this.props.faxAndEmailScheduleDate)) {
      this.setState({
        reportSendStartDate: _.get(this.props, 'faxAndEmailScheduleDate.reportStartDate', moment().subtract(30, "d").format()),
        reportSendEndDate: _.get(this.props, 'faxAndEmailScheduleDate.reportEndDate', moment().endOf("day").utc().format()),
        reportSendDate: _.get(this.props, 'faxAndEmailScheduleDate.reportSendDate', null)
      });
    }
  }

  validateTime(event){
    if(event && event.target && event.target.value){
      const todayDate = moment().format('YYYY-MM-DD');
      if(event.target.value < todayDate){
        this.setState({ reportSendError: "Please select Date and Time greater or equal to Today's Date" });
        return true
      }else{
        this.setState({ reportSendError: null, reportSendDate : event.target.value, reportSendStartDate: moment(event.target.value).subtract(30, 'days').format(), reportSendEndDate: moment(event.target.value).format() });
      }
    }else{
      this.setState({ reportSendError: null, reportSendDate : '' });
    }
  }
  dateRange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    let dateFrom;
    let dateTo = moment(this.state.reportSendDate).endOf("day").utc().format();
    if (value == 30) {
      dateFrom = moment(this.state.reportSendDate).subtract(30, "d").format();
    }
    if (value == 60) {
      dateFrom = moment(this.state.reportSendDate).subtract(60, "d").format();
    }
    if (value == 90) {
      dateFrom = moment(this.state.reportSendDate).subtract(90, "d").format();
    }

    if (value == "custom") {
      dateFrom = moment(this.state.reportSendDate).subtract(30, "d").format();;
      this.setState({ dateRageFilter: true })
    } else {
      this.setState({ dateRageFilter: false })
    }
    this.setState({ reportSendStartDate: dateFrom, reportSendEndDate: dateTo })
  }
  selectCustomDate(event) {
    const value = event.target.value;
    const name = event.target.name;
    if (name === 'startDate') {
      const startDate = moment(value);
      const endDate = moment(this.state.reportSendEndDate);

      // Allow today, but not future dates
      if (startDate.isAfter(moment(this.state.reportSendEndDate), 'day')) {
        this.setState({ dateRangeError: 'Start date cannot be in the future' })
        return;
      }

      // Check end date is not before start date
      if (this.state.reportSendEndDate && endDate.isBefore(startDate, 'day')) {
        this.setState({ dateRangeError: 'End date cannot be before start date' })
        return;
      }
      if (value) {
        this.setState({ reportSendStartDate: startDate.format(), dateRangeError: null });
      } else {
        this.setState({ reportSendStartDate: '', dateRangeError: null });
      }
    }

    if (name === 'endDate') {
      const endDate = moment(value);
      const startDate = moment(this.state.reportSendStartDate);
      if (!this.state.reportSendStartDate) {
        this.setState({ dateRangeError: 'Please select start date' })
        return;
      }
      // Allow today, but not future dates
      // if (moment(this.state.reportSendStartDate).isAfter(moment(endDate), 'day')) {
      //   this.setState({ dateRangeError : 'End date cannot be in the future', reportSendEndDate : ''})
      //   return;
      // }

      // Check end date is not before start date
      if (this.state.reportSendStartDate && endDate.isBefore(this.state.reportSendStartDate, 'day')) {
        this.setState({ dateRangeError: 'End date cannot be before start date', reportSendEndDate: '' })
        return;
      }

      this.setState({ reportSendEndDate: endDate.format(), dateRangeError: null });
    }

  }
  submitForm() {
    if (!this.state.reportSendDate) {
      this.setState({ reportSendError: 'Please select report send date' })
      return;
    }
    if(!this.state.time){
      this.setState({timeError: 'Please select report send time' })
      return;
    }
    if (this.state.dateRangeError || this.state.reportSendError) {
      return;
    }
    if (!moment(this.state.reportSendDate).isValid()) {
      this.setState({ reportSendError: 'Report send date is Invalid' })
    }
    if (!moment(this.state.reportSendStartDate).isValid() || !moment(this.state.reportSendEndDate).isValid()) {
      this.setState({ dateRangeError: 'Report range Start date or End date is Invalid' })
    }
    const userTimeZone = moment.tz.guess();

    this.props.dispatch({
      type: "DO_SAVE_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
      payload: {
        user: this.props.profile._id,
        faxAndEmailScheduleDate: {
          reportSendDate: moment(this.state.reportSendDate).tz(userTimeZone).format(),
          reportStartDate: moment(this.state.reportSendStartDate).tz(userTimeZone).format(),
          reportEndDate: moment(this.state.reportSendEndDate).tz(userTimeZone).format()
        }
      }
    });
    // setTimeout(() => {
    //   const userId = this.props.profile._id;
    //   this.props.dispatch({
    //     type: "DO_GET_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
    //     payload: {
    //       user: userId
    //     }
    //   });
    // }, 1500);
  }
  clearForm() {
    Swal.fire({
      title: 'Are you sure you want to cancel?',
      text: "If you cancel, you will no longer receive the log book report on the scheduled date.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Cancel it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.dispatch({
          type: "DO_SAVE_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
          payload: {
            user: this.props.profile._id,
            faxAndEmailScheduleDate: {}
          }
        });
        setTimeout(() => {
          const userId = this.props.profile._id;
          this.props.dispatch({
            type: "DO_GET_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
            payload: {
              user: userId
            }
          });
        }, 1500);
        this.setState({
          reportSendError: null,
          reportSendStartDate: _.get(this.props, 'faxAndEmailScheduleDate.reportStartDate', moment().subtract(30, "d").format()),
          reportSendEndDate: _.get(this.props, 'faxAndEmailScheduleDate.reportEndDate', moment().endOf("day").utc().format()),
          reportSendDate: _.get(this.props, 'faxAndEmailScheduleDate.reportSendDate', null),
          dateRageFilter: false,
          dateRangeError: null,
          refreshKey: Math.random() * 100
        })

      }
    })
  }
  saveCustomScheduleInfo(data) {
    if (data) {
      const notifyReadingMonthlyReport = {
        emailIds: data.emailIds,
        faxNumbers: data.faxNumbers
      }
      this.props.dispatch({
        type: "DO_SAVE_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
        payload: {
          user: this.props.profile._id,
          faxAndEmailReportScheduleNotify: notifyReadingMonthlyReport
        }
      });
      setTimeout(() => {
        const userId = this.props.profile._id;
        this.props.dispatch({
          type: "DO_GET_PATIENT_REPORT_SCHEDULAR_CONFIGURATION",
          payload: {
            user: userId
          }
        });
      }, 1500);
    }
  }
  handleTimeChange(event) {
    const validTime =  moment(event, 'hh:mm A', true).isValid();
    if(!validTime){
      this.setState({timeError : 'Invalid time format. Please use "hh:mm AM/PM"'});
      return
    }
    if(!this.state.reportSendDate) {
      this.setState({timeError : 'Please select a date first'});
      return
    }
    const date = moment(this.state.reportSendDate).hour(event.hour()).minute(event.minute()).second(0);
    const now = moment();
    if(date.isBefore(now)){
      this.setState({ timeError: "Please select Time greater or equal to Today's Time" });
      return true
    }
    this.setState({time : event, timeError : null, reportSendDate : date})
  }
  render() {
    return (
      <div>
        <div
          className="col-12 mx-auto mt-5">
          <div className="alert alert-info text-center">
           The schedule report will be sent to the Main Care Provider, {this.props.profile && this.props.profile.mainCareProvider && this.props.profile.mainCareProvider.fname ?
              this.props.profile.mainCareProvider.fname + " " + this.props.profile.mainCareProvider.lname : ""} by fax and email from their profile.
          </div>
          <Row className="header-device-list">
            <Col sm="8" className="center-label remove-table-padding">
              {!this.props.hideTitle && (
                <h3 className="text-center title-device">
                  <i className="mdi mdi-clock-outline mr-1" style={{ fontSize: '20px' }}></i>Schedule Report Configuration
                </h3>
              )}
            </Col>
            <Col sm="4" className="d-flex justify-content-end align-items-center remove-table-padding">
              {!this.props.ongoingSaveProfileConfigration && (
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn btn-info delete-note-click"
                    style={{ marginRight: 10 }}
                    onClick={() => this.clearForm()}
                  >
                    <i className="mdi mdi-close-circle" style={{ fontSize: 20, marginRight: 8 }}></i>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-info ml-2 save-configration"
                    style={{ marginRight: 10 }}
                    onClick={() => this.submitForm()}
                    disabled={this.state.reportSendDate ? false : true}
                  >
                    <i className="mdi mdi-check-circle" style={{ fontSize: 20, marginRight: 8 }}></i>
                    Submit
                  </button>
                </div>)}
            </Col>
          </Row>
          {this.props.ongoingPatientReportSchedularConfig && (
            <LottieLoader
              loadLoop={true}
              autoplayLoop={true}
              source={lottieLoaderFile}
              Lheight={150}
              Lwidth={150}
              subTitle={"Please Wait ..."}
            />
          )}
          {!this.props.ongoingPatientReportSchedularConfig && (
            <div>
              <BootstrapTable
                key={this.state.refreshKey}
                wrapperClasses="table-responsive"
                keyField="id"
                filterPosition="top"
                data={this.state.SchedularReportConfiguration && _.size(this.state.SchedularReportConfiguration) > 0 ? this.state.SchedularReportConfiguration : []}
                cellEdit={
                  cellEditFactory({
                    mode: 'click',
                    blurToSave: false,
                  })
                }
                noDataIndication={() => (
                  <div>
                    <LottieLoader
                      loadLoop={false}
                      autoplayLoop={true}
                      source={lottieEmptyFile}
                      Lheight={200}
                      Lwidth={200}
                      titleSmall={"Sorry! No Report found :("}
                      subTitleSmall={"We can't find any report."}
                    />
                  </div>
                )}
                columns={[
                  {
                    dataField: "key",
                    text: "Name of the configuration",
                    headerStyle: (colum, colIndex) => {
                      return {
                        padding: "16px 8px",
                        fontSize: "15px",
                      };
                    },
                    editable: false,
                  },
                  {
                    dataField: "date",
                    text: "Email and Fax report send date-time",
                    headerStyle: (colum, colIndex) => {
                      return {
                        padding: "16px 8px",
                        fontSize: "15px",
                        width: '35%'
                      };
                    },
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
                      return (
                        <div className="d-flex">
                        <div>
                          <Input
                          type="date"
                          name="reportSendDate"
                          rows={10}
                          min={moment().format('YYYY-MM-DD')}
                          onChange={(event) => this.validateTime(event)}
                          value={moment(this.state.reportSendDate).format('YYYY-MM-DD') || ''}
                          defaultValue={moment(this.state.reportSendDate).format('YYYY-MM-DD') || ''}
                          />
                          {this.state.reportSendError && (<Label
                            style={{
                              color: "red",
                              textAlign: "left",
                              padding: 5,
                              'marginBottom': '-6px'
                            }}>{this.state.reportSendError}</Label>)}
                        </div>
                        <div className="ml-1">
                        <Datetime
                          dateFormat={false}
                          inputProps={{
                            placeholder: "00:00",
                            required: true,
                            disabled: this.state.reportSendDate ? false : true
                          }}
                          onChange={(event) =>
                            this.handleTimeChange(event)
                          }
                          value={this.state.time}
                        />
                        {this.state.timeError && (<Label
                          style={{
                            color: "red",
                            textAlign: "left",
                            padding: 5,
                            'marginBottom' : '-6px'
                          }}>{this.state.timeError}</Label>)}
                        </div>
                        </div>
                      );
                    },
                    formatter: (cell, row) => {
                      return <div className="text-center" style={{ cursor: 'pointer' }}>{this.state.reportSendDate ? moment(this.state.reportSendDate).format('MMMM DD, YYYY hh:mm A') : "Select date"}</div>;
                    },
                    editor: {
                      type: Type.DATE
                    },
                    sort: false
                  },
                  {
                    dataField: "date",
                    text: "Graph and log book report date range",
                    headerStyle: (colum, colIndex) => {
                      return {
                        padding: "16px 8px",
                        fontSize: "15px",
                      };
                    },
                    formatter: (cell, row) => {
                      return <div className="text-center" style={{ cursor: 'pointer' }}>{this.state.reportSendDate ? moment(this.state.reportSendStartDate).format('MMMM DD, YYYY') + ' - ' + moment(this.state.reportSendEndDate).format('MMMM DD, YYYY') : 'Select date range'}</div>;
                    },
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
                      if (!this.state.reportSendDate) {
                        return (<Label
                          style={{
                            color: "red",
                            textAlign: "center",
                            fontSize: '15px'
                          }}
                        >
                          Please select first email and fax report send date
                        </Label>)
                      } else {
                        return (
                          <div>
                            <div className="text-center mb-2">{this.state.reportSendDate ? moment(this.state.reportSendStartDate).format('MMMM DD, YYYY') + ' - ' + moment(this.state.reportSendEndDate).format('MMMM DD, YYYY') : "-"}</div>
                            <div className="form-group mb-2">
                              <select
                                name="gender"
                                className="form-control"
                                onChange={(event) => this.dateRange(event)}
                                disabled={!this.state.reportSendDate}
                              >
                                <option value="30">30 days</option>
                                <option value="60">60 days</option>
                                <option value="90">90 days</option>
                                <option value="custom">Custom date</option>
                              </select>
                            </div>
                            <Row
                              form
                              hidden={!this.state.dateRageFilter}
                              className="text-center col-md-12"
                            >
                              <Col md={6}>
                                <FormGroup className="text-left">
                                  <Label for="exampleEmail">Start Date</Label>
                                  <Input
                                    className="input-date-filter"
                                    type="date"
                                    name="startDate"
                                    max={moment(this.state.reportSendDate).endOf("day").format("YYYY-MM-DD")}
                                    value={this.state.reportSendStartDate ? moment(this.state.reportSendStartDate).format("YYYY-MM-DD") : ''}
                                    onChange={(event) => this.selectCustomDate(event)}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="text-left">
                                  <Label for="examplePassword">End Date</Label>
                                  <Input
                                    className="input-date-filter"
                                    type="date"
                                    name="endDate"
                                    max={moment(this.state.reportSendDate).endOf("day").format("YYYY-MM-DD")}
                                    value={this.state.reportSendEndDate ? moment(this.state.reportSendEndDate).format("YYYY-MM-DD") : ''}
                                    onChange={(event) => this.selectCustomDate(event)}
                                  />
                                </FormGroup>
                              </Col>
                              <Label
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  marginTop: "-15px",
                                  marginLeft: "5px"
                                }}
                              >
                                {this.state.dateRangeError}
                              </Label>
                            </Row>
                          </div>
                        );
                      }
                    },
                    sort: false,
                    editable: true,
                  },
                ]}
                filter={filterFactory()}
              />
            </div>
          )}
          {!this.props.ongoingPatientReportSchedularConfig && (
            <ReportConfigration
              isEditable={true}
              notifyReadingMonthlyReport={this.props.faxAndEmailReportScheduleNotify}
              saveCCMDetails={this.saveCustomScheduleInfo}
              isSchedular={true}
            />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ user, careprovider }) => {
  const { authenticated, userDetails, profile } = user;
  const { faxAndEmailScheduleDate, ongoingPatientReportSchedularConfig, faxAndEmailReportScheduleNotify } = careprovider;
  return {
    authenticated,
    userDetails,
    profile,
    ongoingPatientReportSchedularConfig,
    faxAndEmailScheduleDate,
    faxAndEmailReportScheduleNotify
  };
};

export default connect(mapStateToProps)(SchedularConfigurationReport);
